import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import findResult, { findSelectedInCategory } from '@/utils/resultsHelper';
import { firstResponseError } from '@/utils/errors';
import { saveStates, states } from '@/constants/lifecycle';
import { updateConfigurationProperties, updateDefaultRoleConfiguration } from '@/configurations/actions';
import { configurationCodes } from '@/configurations/constants';
import Dialog from '@/components/dialogs/Dialog';
import fetch, { fetchConfig } from '@/hooks/fetch';
import RoleDefaultRoleTable from './RoleDefaultRoleTable';
import { fetchDefaultRole, hideDefaultRole } from '../actions';

const RoleDefaultRoleDialog = ({
  allowConfigurationRead,
  changeDefaultRole,
  fetchDefault,
  hide,
  name,
  readErrors,
  role,
  saveErrors,
  saveStatus,
  theme,
  updateProperties,
}) => {
  const intl = useIntl();
  fetch.useFetch(fetchDefault, states.NONE, fetchConfig([], () => allowConfigurationRead));
  return (
    <Dialog
      className="aridhia-default-user-dialog smallwizard"
      contentClassName="pt-0"
      error={firstResponseError([...readErrors, ...saveErrors])}
      icon="cog"
      inProgress={saveStatus === states.PENDING}
      message="configurations.default.role.message"
      minimumDataEntryMet={role}
      onClose={hide}
      onDismiss={() => updateProperties({ saveErrors: [] })}
      onSave={() => changeDefaultRole(role)}
      saveMessageId="configurations.default.role.dialog.button"
      size="small"
      theme={theme}
      title={intl.formatMessage({ id: 'configurations.default.role.title' })}
      values={{ name }}
    >
      <RoleDefaultRoleTable />
    </Dialog>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { configurations: { read } } } },
  configurations: { configurations },
  roles: { roles },
}) => {
  const configuration = findResult(configurations, 'all', configurationCodes.DEFAULT_ROLE) || {
    ...saveStates,
  };
  const [defaultRole] = roles.defaultRole.results;
  const [newRole] = findSelectedInCategory(roles, 'defaultSelection');

  return ({
    allowConfigurationRead: read,
    name: defaultRole.name,
    readErrors: defaultRole.readErrors,
    readStatus: defaultRole.readStatus,
    role: newRole?.code !== defaultRole.code ? newRole : null,
    saveErrors: configuration.saveErrors,
    saveStatus: configuration.saveStatus,
  });
};

const mapDispatchToProps = {
  changeDefaultRole: (role) => updateDefaultRoleConfiguration('all', role),
  fetchDefault: fetchDefaultRole,
  hide: hideDefaultRole,
  updateProperties: (properties) => (
    updateConfigurationProperties('all', configurationCodes.DEFAULT_ROLE, properties)
  ),
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleDefaultRoleDialog);
